import type { AdminIconProps } from "./UsersIcon";

/** Pulse / heartbeat glyph. */
export function HealthIcon({ className, ...rest }: AdminIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden={rest["aria-hidden"] ?? true}
    >
      <path d="M3 12h4l2-7 4 14 2-7h6" />
    </svg>
  );
}
